import { IInitAction } from './init'

// Action types
export enum types {
  PUT_CREDENTIALS = 'PUT_CREDENTIALS',
  LOGOUT = 'LOGOUT',
  AUTH_FAILURE = 'AUTH_FAILURE',
}

export interface IPutCredentialsAction {
  type: types.PUT_CREDENTIALS
  credentials: IAuth
}

export interface ILogoutAction {
  type: types.LOGOUT
}

export interface IFailure {
  type: types.AUTH_FAILURE
  message: string
}

export type AuthActionsType =
  | IPutCredentialsAction
  | ILogoutAction
  | IFailure
  | IInitAction

// Reducer types
export interface IAuthorizationRoles {
  isSystemAdmin: boolean
  isSystemApprover: boolean
  isSystemSupport: boolean
}
export interface IPermissions extends IAuthorizationRoles {
  editorForGroups: string[]
  restrictedAreasReadable: string[]
  restrictedAreasWritable: string[]
}

export interface IRight {
  level?: string
  permission?: string
  groupName?: string
}

export interface IRights {
  raw: string[]
  parsed: IRight[]
}

export interface IAuth {
  token?: string
  uid?: string
  family_name?: string
  given_name?: string
  rights: IRights
  permissions: IPermissions
}

export interface IPermissionsSelector {
  [key: string]: any
}

export interface IAreaSelector extends IPermissionsSelector {
  area: string
}
